import { render, staticRenderFns } from "./PopupPreview.vue?vue&type=template&id=4f2ff132&scoped=true"
import script from "./PopupPreview.vue?vue&type=script&lang=js"
export * from "./PopupPreview.vue?vue&type=script&lang=js"
import style0 from "./PopupPreview.vue?vue&type=style&index=0&id=4f2ff132&prod&lang=stylus&scoped=true"
import style1 from "./PopupPreview.vue?vue&type=style&index=1&id=4f2ff132&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2ff132",
  null
  
)

export default component.exports